import wizardStore from './wizardStore'
import messageInformationStore from './messageInformationStore'
import coldChainStore from './coldChainStore'
import transportChainCostStore from './transportChainCostStore'
import componentSelectionStore from './componentSelectionStore'

const storeModule = {
  state: () => (
    {
      ...wizardStore.state,
      ...messageInformationStore.state,
      ...coldChainStore.state,
      ...transportChainCostStore.state,
      ...componentSelectionStore.state

    }
  ),
  mutations: {
    ...wizardStore.mutations,
    ...messageInformationStore.mutations,
    ...coldChainStore.mutations,
    ...transportChainCostStore.mutations,
    ...componentSelectionStore.mutations

  },
  actions: {
    ...wizardStore.actions,
    ...coldChainStore.actions

  },
  getters: {
    ...wizardStore.getters,
    ...messageInformationStore.getters,
    ...transportChainCostStore.getters,
    ...componentSelectionStore.getters,
    ...coldChainStore.getters

  }
}

export default storeModule
